<!-- Copyright (C) GridGain Systems. All Rights Reserved.
   _________        _____ __________________        _____
   __  ____/___________(_)______  /__  ____/______ ____(_)_______
   _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
   / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
   \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/ -->

@if (data.title) {
  <h1 mat-dialog-title gta="prompt-dialog__title">{{ data.title }}</h1>
}
<form
  mat-dialog-content
  [formGroup]="form"
  id="prompt-dialog-form"
  (ngSubmit)="onSubmit()"
  angulartics2On="submit"
  angularticsCategory="FormSubmit"
  angularticsAction="PromptDialog"
  [angularticsLabel]="data.title ?? ''"
>
  @if (data.message) {
    <p gta="prompt-dialog__message">{{ data.message }}</p>
  }
  <mat-form-field gta="prompt-dialog__form-field">
    <input matInput cdkFocusInitial formControlName="value" gta="prompt-input" [placeholder]="data.placeholder ?? ''" />
  </mat-form-field>
</form>
<div mat-dialog-actions>
  <button
    mat-button
    [mat-dialog-close]="null"
    type="button"
    gta="prompt-dialog__dismiss-button"
    angulartics2On="click"
    angularticsCategory="DialogDismiss"
    angularticsAction="PromptDialog"
    [angularticsLabel]="data.title ?? ''"
    >{{ data.dismissButtonLabel || 'Cancel' }}</button
  >
  <button
    mat-button
    [disabled]="!form.value.value"
    type="submit"
    form="prompt-dialog-form"
    gta="prompt-dialog__submit-button"
    >{{ data.submitButtonLabel || 'Save' }}</button
  >
</div>
